export var RumEventType = {
  ACTION: 'action',
  ERROR: 'error',
  LONG_TASK: 'long_task',
  VIEW: 'view',
  RESOURCE: 'resource',
  VITAL: 'vital'
};
export var RumLongTaskEntryType = {
  LONG_TASK: 'long-task',
  LONG_ANIMATION_FRAME: 'long-animation-frame'
};
export var ViewLoadingType = {
  INITIAL_LOAD: 'initial_load',
  ROUTE_CHANGE: 'route_change',
  BF_CACHE: 'bf_cache'
};
export var ActionType = {
  CLICK: 'click',
  CUSTOM: 'custom'
};
export var FrustrationType = {
  RAGE_CLICK: 'rage_click',
  ERROR_CLICK: 'error_click',
  DEAD_CLICK: 'dead_click'
};
export var VitalType = {
  DURATION: 'duration',
  OPERATION_STEP: 'operation_step'
};